export default {
  login: {
    title: 'Ins·代理商平台',
    username: '用戶名',
    password: '密碼',
    login: '登錄',
    welcomeBack: '歡迎回來',
    loginSuccess: '登錄成功',
    loginFailed: '登錄失敗',
    networkError: '網絡錯誤，請稍後重試',
    error: {
      username_required: '請輸入用戶名',
      password_required: '請輸入密碼',
      login_success: '登錄成功',
      login_failed: '登錄失敗'
    }
  },
  common: {
    confirm: '確認',
    cancel: '取消',
    save: '保存',
    delete: '刪除',
    edit: '編輯',
    create: '創建',
    search: '搜索',
    reset: '重置',
    loading: '加載中',
    success: '成功',
    error: '錯誤',
    warning: '警告',
    info: '信息',
    tip: '提示',
    appName: '代理商管理系統',
    none: '無'
  },
  header: {
    balance: '賬戶餘額',
    recharge: '充值',
    logout: '退出登錄',
    profile: '個人信息',
    welcome: '歡迎'
  },
  menu: {
    dashboard: '儀表盤',
    account: '我的賬戶',
    billing: '計費記錄',
    proxy: '代理管理',
    staticproxy: '靜態住宅代理',
    users: '用戶管理'
  },
  dashboard: {
    title: '儀表盤',
    totalBalance: '總餘額',
    todayIncome: '今日收入',
    monthlyIncome: '本月收入',
    yearlyIncome: '年度收入',
    recentTransactions: '最近交易',
    statistics: '統計數據'
  },
  account: {
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    notifyUrl: '回調地址',
    copyNotifyUrl: '複製回調地址',
    resetKey: '重置密鑰',
    resetWarning: '重置 API 密鑰將使現有密鑰失效，您確定要繼續嗎？',
    resetPassword: '重置密碼',
    currentBalance: '當前餘額',
    rechargeAmount: '充值金額',
    paymentMethod: '支付方式',
    alipay: '支付寶',
    wechat: '微信',
    suggestedAmounts: {
        ten: '¥10',
        fifty: '¥50',
        hundred: '¥100',
        twoHundred: '¥200',
        fiveHundred: '¥500',
        thousand: '¥1000'
    },
    error: {
      recharge_amount_required: '請輸入充值金額',
      recharge_amount_invalid: '充值金額必須大於0',
      payment_method_required: '請選擇支付方式',
      api_key_required: '請輸入API密鑰',
      copy: '複製失敗',
      currentRequired: '請輸入當前密碼',
      newRequired: '請輸入新密碼',
      confirmRequired: '請輸入確認密碼',
      passwordLength: '密碼長度至少6位',
      passwordMismatch: '兩次輸入的密碼不一致'
    },
    success: {
      copy: '複製成功'
    },
    passwordFailed: '密碼錯誤，請重新輸入',
    modifyPassword: '修改登錄密碼',
    currentPassword: '當前密碼',
    newPassword: '新密碼',
    confirmPassword: '確認密碼',
    confirmChange: '確認修改',
    recharge: '充值',
    remainingTime: '剩餘時間',
    scanQRCode: '請使用手機掃描二維碼完成支付',
    paymentAmount: '支付金額'
  },
  billing: {
    title: '賬單管理',
    orderNo: '訂單編號',
    amount: '金額',
    status: '狀態',
    createTime: '創建時間',
    paymentMethod: '支付方式',
    // 統計卡片
    monthlyConsume: '本月消費',
    monthlyRecharge: '本月充值',
    // 搜索表單
    transactionType: '交易類型',
    orderType: '訂單類型',
    transactionTime: '交易時間',
    startDate: '開始日期',
    endDate: '結束日期',
    all: '全部',
    consume: '消費',
    refund: '退款',
    recharge: '充值',
    staticProxy: '靜態代理訂單',
    ipRenewal: 'IP續期',
    rechargeOrder: '充值訂單',
    search: '搜索',
    reset: '重置',
    export: '導出',
    // 表格列
    orderNumber: '訂單號',
    transactionTypeLabel: '交易類型',
    changeAmount: '變動金額',
    beforeBalance: '變動前金額',
    afterBalance: '變動後金額',
    orderTypeLabel: '訂單類型',
    transactionDate: '交易日期',
    // 交易詳情彈窗
    transactionDetail: '交易詳情',
    remark: '備註',
    noRemark: '無',
    // 消息提示
    fetchTransactionsFailed: '獲取交易記錄失敗',
    fetchStatsFailed: '獲取月度統計失敗',
    exportPreparing: '正在準備導出文件...',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    loadConditionsFailed: '加載搜索條件失敗',
    // 檔案名稱和錯誤訊息
    transactionRecords: '交易記錄',
    exportTransactionsFailed: '匯出交易記錄失敗',
    exportFailedPrefix: '匯出失敗',
    unknownError: '未知錯誤',
    pleaseSelectRecords: '請選擇要導出的記錄'
   },
   proxy: {
    title: '代理管理',
    proxyList: '代理列表',
    createProxy: '創建代理',
    editProxy: '編輯代理',
    proxyDetail: '代理詳情',
    // 表格列
    id: 'ID',
    ip: 'IP',
    oldIp: '舊IP',
    port: '端口號',
    location: 'IP歸屬地',
    orderNo: '訂單號',
    days: '天數',
    traffic: '流量',
    totalTraffic: '總流量',
    usedTraffic: '已使用流量',
    expirationTime: '過期日期',
    tag: '標籤',
    createTime: '下單時間',
    operations: '操作',
    renewalTime: '續期時間',
    renewalResult: '續期結果',
    reason: '原因',
    // 狀態
    enableStatus: '啟用狀態',
    onlineStatus: '在線狀態',
    enabled: '啟用',
    disabled: '禁用',
    online: '在線',
    offline: '離線',
    success: '成功',
    failed: '失敗',
    // Actions
    copyProxy: '複製代理',
    viewDetails: '查看詳情',
    details: '詳情',
    renewal: '續期',
    // 標籤頁
    purchasedIpList: '已購IP列表',
    renewalRecord: '續期記錄',
    // 流量相關
     unlimitedTraffic: '無限流量',
     // 圖標說明
     iconLegend: '圖標說明'
   },
  breadcrumb: {
    dashboard: '儀表盤',
    account: '我的賬戶',
    billing: '計費',
    proxy: '代理管理',
    staticproxy: '靜態住宅代理',
    users: '用戶管理',
    resellerManagement: '代理商管理',
    resellerlist: '代理商列表',
    reselleranalytics: '统计分析'
  },
  user: {
    username: '用戶名',
    email: '郵箱',
    status: '狀態',
    isReseller: '是否代理商',
    yes: '是',
    no: '否',
    actions: '操作',
    usernamePlaceholder: '請輸入用戶名',
    statusPlaceholder: '請選擇狀態',
    statusAll: '全部',
    statusActive: '啟用',
    statusDisabled: '禁用',
    createTime: '創建時間',
    updateTime: '更新時間',
    lastLoginTime: '最後登錄時間',
    usernameRequired: '請輸入用戶名',
    usernameLengthLimit: '用戶名長度應在3-20個字符之間',
    passwordRequired: '請輸入密碼',
    passwordLengthLimit: '密碼長度不能少於6個字符',
    remark: '備註',
    addUser: '新增用戶',
    password: '密碼',
    confirmStatusChange: '確認{action}該用戶?',
    enable: '啟用',
    disable: '禁用',
    tip: '提示',
    statusChangeSuccess: '{action}成功',
    statusChangeFailed: '{action}失敗',
    statusUpdateFailed: '狀態更新失敗',
    submitSuccess: '提交成功',
    getUserListFailed: '獲取用戶列表失敗',
    confirmRenewIP: '確認為該IP續期?',
    renewSuccess: '續期成功'
  },
  
  // 代理管理頁面
  proxyStatic: {
    // 標籤頁
    purchase: '購買',
    purchased: '已購IP列表',
    renewalRecord: '續期記錄',
    
    // 購買表單
    selectPackage: '選擇套餐',
    selectRegion: '選擇地區',
    deliveryProtocol: '交付協議',
    pleaseSelectRegion: '請選擇地區',
    quantity: '數量：',
    calculating: '計算中...',
    paymentAmount: '支付金額：',
    includeExtraFee: '含額外費用',
    payNow: '立即支付',
    reset: '重置',
    
    // 服務特點
    highSpeedStable: '高速穩定，99.9%在線率保證',
    globalCoverage: '全球覆蓋，支持200+國家和地區',
    unlimitedBandwidth: '無限帶寬，不限制並發連接數',
    professionalSupport: '專業技術支持，7x24小時在線服務',
    
    // 專業特點
    realUserSimulation: '真實用戶模擬',
    realUserSimulationDesc: '更難被網站識別為代理，提高隱蔽性',
    highAnonymity: '高匿名性',
    highAnonymityDesc: '減少了被監測和封鎖的風險',
    lowBlockRate: '低封鎖率',
    lowBlockRateDesc: '使用IP時被網站封鎖的概率較低',
    highAuthenticity: '高真實性',
    highAuthenticityDesc: '更難被網站識別為代理，提高隱蔽性',
    betterStability: '更好的穩定性',
    betterStabilityDesc: '更難被網站識別為代理，提高隱蔽性',
    
    // 訂單確認
    confirmOrderInfo: '確認訂單信息',
    packageInfo: '套餐信息',
    region: '地區',
    protocol: '協議',
    tag: '標籤',
    pleaseEnterTag: '請輸入標籤（可選）',
    maxCharacters: '最多20個字符',
    paymentMethod: '支付方式',
    
    // 訂單號
    orderNumber: '訂單號',
    isReseller: '是否代理商',
    orderTime: '下單時間',
    
    // IP狀態標籤
    activeIPs: '活躍IP',
    expiringIPs: '即將過期IP',
    expiredIPs: '已過期IP',
    daysToExpire: '天後到期',
    
    // 搜索表單
    enterIPAddress: '輸入IP地址',
    addIP: '+ 添加IP',
    pleaseEnterOrderNo: '請輸入訂單號',
    pleaseEnterOrderNumber: '請輸入訂單號',
    collapse: '收起',
    expand: '展開',
    pleaseEnterTag: '請輸入標籤',
    all: '全部',
    yes: '是',
    no: '否',
    startDate: '開始日期',
    endDate: '結束日期',
    to: '至',
    pleaseEnterUserID: '請輸入用戶ID',
    enableStatus: '啟用狀態',
    pleaseSelect: '請選擇',
    enabled: '啟用',
    disabled: '禁用',
    onlineStatus: '在線狀態',
    search: '搜索',
    export: '導出',
    
    // 續期記錄搜索
    userID: '用戶ID',
    renewalStatus: '續期狀態',
    success: '成功',
    failed: '失敗',
    renewalTime: '續期時間',
    
    // 支付確認
    confirmPayment: '確認支付',
    confirmPaymentMessage: '確認支付 ¥{amount} 購買代理服務？',
    confirm: '確認',
    cancel: '取消',
    paymentSuccess: '支付成功！訂單號：{orderNo}',
    paymentFailed: '支付失敗',
    paymentFailedRetry: '支付失敗，請重試',
    
    // 表格列名
    renewalResult: '續期結果',
    totalTraffic: '總流量',
    usedTraffic: '已用流量',
    enableStatus: '啟用狀態',
    
    // 通用
    none: '無',
    
    // 錯誤提示
    priceCalculationFailed: '價格計算失敗',
    getPackageListFailed: '獲取套餐列表失敗',
    getRegionListFailed: '獲取地區列表失敗',
    getProxyListFailed: '獲取代理列表失敗',
    getRenewalListFailed: '獲取續期記錄失敗',
    pleaseEnterValidIPFormat: '請輸入有效的IP地址格式',
    proxyInfoCopied: '代理信息已複製到剪貼板',
    getProxyInfoFailed: '獲取代理信息失敗',
    copyProxyInfoFailed: '複製代理信息失敗',
    networkError: '網絡錯誤',
    copyFailedManualCopy: '複製失敗，請手動複製',
    renewalSuccess: '續期成功',
    renewalFailed: '續期失敗',
    preparingExport: '正在準備導出文件...',
    exportSuccess: '導出成功',
    exportFailed: '導出失敗',
    pleaseSelectPackage: '請選擇套餐',
    pleaseEnterQuantity: '請輸入數量',
    pleaseSelectPaymentMethod: '請選擇支付方式',
    balancePayment: '餘額支付',
    alipay: '支付寶',
    wechatPay: '微信支付',
    confirmRenewProxy: '確定要續期該代理嗎？',
    pleaseSelectRecords: '請選擇要導出的記錄',
    
    // 批量修改標籤
     batchUpdateTag: '批量修改標籤',
     newTag: '新標籤',
     pleaseEnterNewTag: '請輸入新標籤',
     selectedRecordsCount: '已選擇 {count} 條記錄',
     batchUpdateTagSuccess: '批量修改標籤成功',
     batchUpdateTagFailed: '批量修改標籤失敗',
     
     // 批量刷新代理信息
        batchSyncProxyInfo: '批量刷新代理信息',
        pleaseSelectRecordsForSync: '請選擇要刷新代理信息的記錄',
        pleaseSelectRecordsForTag: '請選擇要修改標籤的記錄',
        
        // 批量複製代理
         batchCopyProxy: '批量複製代理',
         pleaseSelectRecordsForCopy: '請選擇要複製的記錄',
    batchCopySuccess: '已成功複製 {count} 個代理信息到剪貼板',
     getBatchProxyInfoFailed: '獲取批量代理信息失敗',
     batchCopyProxyFailed: '批量複製代理失敗',
         batchCopyProxyFailed: '批量複製代理失敗',
    
    // 新增列
    hostname: '主機',
    accountName: '用戶名',
    password: '密碼',
    
    // 複製功能
    hostnameCopied: '主機已複製到剪貼板',
    accountNameCopied: '用戶名已複製到剪貼板',
    passwordCopied: '密碼已複製到剪貼板',
    copyFailed: '複製失敗',
    
    // 同步IP功能
    syncIP: '同步IP',
    systemAccount: '系統賬號',
    userID: '用戶ID',
    proxyType: '代理類型',
    ipLocation: 'IP歸屬地',
    productType: '產品類型',
    days: '天數',
    channel: '通道',
    deductBalance: '是否扣餘額',
    unitPrice: '單價',
    tag: '標籤',
    remark: '備註',
    syncExcel: '待同步Excel',
    uploadExcel: '上傳Excel文檔',
    excelTips: '文檔標題需確保有字段"主機，IP地址，端口，账号，密碼，代理ID，线路ID，过期时间"，其中主機和线路ID的值沒有的話可以留空',
    pleaseSelectSystemAccount: '請選擇系統賬號',
    pleaseEnterUserID: '請輸入用戶ID',
    pleaseSelectIPLocation: '請選擇IP歸屬地',
    pleaseSelectProductType: '請選擇產品類型',
    pleaseSelectDays: '請選擇天數',
    pleaseSelectChannel: '請選擇通道',
    pleaseSelectDeductBalance: '請選擇是否扣餘額',
    pleaseEnterUnitPrice: '請輸入單價',
    unitPriceMustGreaterThanZero: '單價必須大於0',
    pleaseUploadExcel: '請上傳Excel文檔',
    onlyExcelAllowed: '只能上傳Excel文件',
    fileSizeLimit: '文件大小不能超過10MB',
    submitSync: '提交同步',
    resetForm: '重置表單',
    syncSuccess: '同步成功',
    syncFailed: '同步失敗',
     getCountryListFailed: '獲取國家列表失敗',
     getProductListFailed: '獲取產品列表失敗',
     gk: 'GK',
     other: '其他',
     thirtyDays: '30天',
     sixtyDays: '60天',
     ninetyDays: '90天',
     
     // 同步IP功能
      syncIP: '同步IP',
      syncIPForm: '同步IP表單',
      systemAccount: '系統賬號',
      pleaseSelectSystemAccount: '請選擇系統賬號',
      pleaseSelectLocation: '請選擇IP歸屬地',
      productType: '產品類型',
      pleaseSelectProduct: '請選擇產品類型',
      pleaseSelectDays: '請選擇天數',
      zone: '通道',
      pleaseSelectZone: '請選擇通道',
      unitPrice: '單價',
      pleaseEnterUnitPrice: '請輸入單價',
      isDeductBalance: '是否扣餘額',
      pleaseSelectDeductBalance: '請選擇是否扣餘額',
      remark: '備註',
      pleaseEnterRemark: '請輸入備註',
      syncExcel: '待同步Excel',
      selectFile: '選擇文件',
      excelTip: '只能上傳xlsx/xls文件，且不超過10MB',
      excelRequirementTip: '注意：Excel文檔的標題行請確保包含"主機"、"IP地址"、"账号"、"密码"、"端口"、"代理ID"、"线路ID"、"过期时间"等字段（字段名必須是簡體中文）',
      submitSync: '提交同步',
      onlyExcelAllowed: '只能上傳Excel文件',
     fileSizeLimit: '文件大小不能超過10MB',
     pleaseSelectFile: '請選擇文件'
   },
  reseller: {
    passwordLengthLimit: '密碼長度不能少於6個字符',
    
    // 充值相關
    rechargeTitle: '充值',
    rechargeAmount: '充值金額',
    rechargeAmountPlaceholder: '請輸入充值金額',
    rechargeRemark: '備註',
    rechargeRemarkPlaceholder: '請輸入備註',
    rechargeAmountRequired: '請輸入充值金額',
    rechargeAmountMin: '最低充值金額為¥1',
    rechargeAmountInvalid: '請輸入有效金額',
    rechargeRemarkRequired: '請輸入備註',
    rechargeConfirm: '確認為該代理商充值¥{amount}？',
    rechargeSuccess: '充值成功',
    rechargeFailed: '充值失敗',
    rechargeProcessing: '正在處理充值...'
  },
  error: {
    '404': '抱歉，您訪問的頁面不存在',
    '403': '抱歉，您沒有權限訪問此頁面',
    back: '返回上頁',
    home: '回到首頁'
  }
}